import { useDispatch, useSelector } from "react-redux";

import { CreateGallery } from "../../redux/gallery";
import { ErrorBanner } from "../../components/banner";
import { Loading } from "../../components/loader";
import { PhotoForm } from "./PhotoForm";
import { Section } from "../../components/section";
import { useNavigate } from "react-router-dom";

export const PhotoCreate = () => {
  const { loading, error } = useSelector((state) => state.gallery);
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const onFormSubmit = (values) => {
    if (window.confirm(`Are you sure you want to save?`)) {
      dispatch(CreateGallery(values));
    }

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/gallery/photos");
      }, 2000);
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <Section>
        {error && <ErrorBanner text={error} />}

        <PhotoForm onFormSubmit={onFormSubmit} />
      </Section>
    </>
  );
};
